import * as store from '@daas-consulting/core-frontend-store';
import { StateToken } from '@ngxs/store';
import { context, feature } from '../remitos.const';
import { RemitosFormStateModel as Model } from './remitos-form.state-model';

const name = store.getName({
  context,
  feature,
  section: store.SectionsNames.form,
});
export const stateTokenName = new StateToken<Model>(name);
export const dataFormPath = `${stateTokenName.getName()}.dataForm`;
